import { memo } from "react";

import { styled, Theme } from "@mui/material/styles";

import { DashboardCard } from "@/dashboard-design-system/Card/DashboardCard";

const PREFIX = "ImageUploader";

export const classes = {
  uploadCard: `${PREFIX}-uploadCard`,
  noPadding: `${PREFIX}-noPadding`,
};

export const StyledCard = memo(
  styled(DashboardCard)(({ theme }: { theme: Theme }) => ({
    [`&.${classes.uploadCard}`]: {
      position: "relative",
      height: "100%",
      backgroundColor: theme.palette.surface.neutral.supershy,
      borderColor: theme.palette.border.neutral.moderate,
      borderStyle: "dashed",
      overflow: "hidden",

      "&:hover": {
        backgroundColor: theme.palette.surface.neutral.supershy,
      },
    },

    [`&.${classes.noPadding}, .${classes.noPadding}`]: {
      padding: 0,
    },
  }))
);
